import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
	providedIn: 'root'
})
export class StoreService {
	constructor(
		private httpService: HttpService
	) { }




	public async getOrSetFromStore<T>(url: string, data: T | null = null): Promise<T | undefined> {
		let result: T | undefined = undefined;

		if (!result) {
			if (!data) {
				result = await this.httpService.getDataWithOfflineCheck<T>(url);
			}
			else {
				result = data;
			}
		}

		return result;
	}


}
